import { render } from "./About.vue?vue&type=template&id=c9c1819c"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"
script.render = render

export default script